<fgb-account-layout titleKey="fitness.tracker.page.title" titleDefault="Connected Apps">
  <fgb-account-panel titleKey="fitness.tracker.card.heading" titleDefault="Connected Apps">
    <fgb-fitness-tracker-card></fgb-fitness-tracker-card>
  </fgb-account-panel>
</fgb-account-layout>
